var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "schedule",
    d: "M11,12.8a.9.9,0,1,0-.9-.9A.9.9,0,0,0,11,12.8Zm4.5,0a.9.9,0,1,0-.9-.9A.9.9,0,0,0,15.5,12.8ZM11,16.4a.9.9,0,1,0-.9-.9A.9.9,0,0,0,11,16.4Zm4.5,0a.9.9,0,1,0-.9-.9A.9.9,0,0,0,15.5,16.4Zm-9-3.6a.9.9,0,1,0-.9-.9A.9.9,0,0,0,6.5,12.8Zm10.8-9h-.9V2.9a.9.9,0,1,0-1.8,0v.9H7.4V2.9a.9.9,0,1,0-1.8,0v.9H4.7A2.7,2.7,0,0,0,2,6.5V17.3A2.7,2.7,0,0,0,4.7,20H17.3A2.7,2.7,0,0,0,20,17.3V6.5a2.7,2.7,0,0,0-2.7-2.7Zm.9,13.5a.9.9,0,0,1-.9.9H4.7a.9.9,0,0,1-.9-.9V9.2H18.2Zm0-9.9H3.8V6.5a.9.9,0,0,1,.9-.9H17.3a.9.9,0,0,1,.9.9Zm-11.7,9a.9.9,0,1,0-.9-.9A.9.9,0,0,0,6.5,16.4Z",
    transform: "translate(-2 -2)",
    fill: "#455079"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b46dd35b4be5c08f5de924c9b873b5ba.svg";
export { ForwardRef as ReactComponent };